import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";


export async function saveTicketRca(payload) {
  try {
    const data = await authenticatedFetch(URL.saveTicketRca, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
    return data;
  } catch (error) {
    console.error("Error executing ticket RCA save:", error);
    throw error;
  }
}
